import { makeStyles } from '@material-ui/core';

const useInputStyles = makeStyles(() => ({
    endAdornmentWrapper: {
        marginRight: '8px',
        marginLeft: '0px',
        marginTop: '4px',
        zIndex: 1,
        cursor: 'auto',
        
        '& svg': {
            color: 'var(--teal-blue)'
        }
    },
    root:{
        '&:focus-within label span, &:hover label span':{
            color:'var(--teal-blue)'
        }
    }
}));

export default useInputStyles;